<template lang="pug">
  div
    v-card
      v-toolbar.elevation-0(height="45" color="gray")
        v-toolbar-title
          h1.subheading {{ $t('labels.commercialService') }}
        v-spacer
        v-btn(small color='pink' dark @click="dialog = true" icon)
          v-icon(small) edit
      v-card-text
        v-layout(column)
          v-layout(row wrap)
            v-flex {{ $t('labels.plan') }}
            v-spacer
            v-flex.font-weight-regular.text-xs-right(v-if="service.commercial.Product.productDetail") {{ service.commercial.Product.productDetail }}
            v-flex.font-weight-regular.text-xs-right(v-else) Not Set
          v-divider
          v-layout(row wrap)
            v-flex {{ $t('labels.fee') }}
            v-spacer
            v-flex.font-weight-regular.text-xs-right {{ service.commercial.softwareFee | currency }}
      v-dialog(v-model='dialog', persistent max-width='300')
        v-card
          v-toolbar.elevation-0(height="45" color="gray")
            v-toolbar-title
              h1.subheading {{ $t('labels.plan') }}
          v-card-text(v-if="!isLoading")
            v-layout(row wrap)
              v-flex(xs12 v-if="checkRightStatus(11)")
                v-select(
                  :items="softwareProduct"
                  :error-messages="productErrors" 
                  :label="$t('labels.plan')"
                  item-text="productDetail"
                  item-value="productID"
                  v-model="editLocation.productID")
              v-flex(xs12 v-if="checkRightStatus(10)")
                v-text-field.right-input(v-model="editLocation.softwareFee"
                  :error-messages="softwareFeeErrors" 
                  label='Fee')

</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import commericalService from '../service.js'
import locationService from '../../Location/service.js'
const { validationMixin } = require('vuelidate')
const {
  required,
  minLength,
  minValue,
} = require('vuelidate/lib/validators')
export default {
  data() {
    return {
      dialog: false,
      isLoading: true,
      isReconcile: false,
      softwareProduct: [],
    }
  },
  computed: {
    ...mapGetters('location', ['location', 'service']),
    ...mapGetters('global', ['comboBox', 'comboBoxByID', 'checkRightStatus']),
    productErrors() {
      const errors = []
      if (!this.$v.editLocation.productID.$dirty) return errors
      if (!this.$v.editLocation.productID.required) errors.push(this.$t('validations.fieldIsRequired'))
      return errors
    },
    softwareFeeErrors() {
      const errors = []
      if (!this.$v.editLocation.softwareFee.$dirty) return errors
      if (!this.$v.editLocation.softwareFee.required) errors.push(this.$t('validations.fieldIsRequired'))
      return errors
    },
  },
  watch: {
    dialog(val) {
      if(val) {
        this.getServiceProduct()
        this.editLocation = _.clone(this.location)
        this.isLoading = false
      }
    }
  },
  mixins: [validationMixin],
  validations: {
    editLocation: {
      productID: {
        required,
        minValue: minValue(1),
      },
      softwareFee: {
        required,
      },
    },
  },
  methods: {
    ...mapActions('location', ['setLocation']),
    getServiceProduct() {
      return locationService.getServiceProduct(this.service.commercial.serviceID)
      .then(result => {
        console.log('product', result)
        this.softwareProduct = result.data
      })
    },
    update() {
      let editData = {
        productID: this.editLocation.productID,
        softwareFee: this.editLocation.softwareFee,
      }
      return locationService.updateProductRelation(this.editLocation.storeID, this.service.commercial.serviceID, this.editLocation)
      .then(result => {
        this.$swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        }).fire({
          type: 'success',
          title: 'Update Successfully'
        })
        this.close()
        this.setLocation(this.editLocation.storeID)
      })
    },
  }
}
</script>

